import Component from './Loader.vue';

export default {
  install(Vue) {
    Vue.component('BkfLoader', Component);
  },
};
